import type { StaffOrgDashboardApiInvoice } from '#/modules/staff/orgDashboard/invoices/api/types/StaffOrgDashboardApiInvoice';
import { getJson } from '#/utils/http/getJson';

export function staffApiFetchInvoices({
  number,
  outstanding,
}: {
  number: string;
  outstanding: boolean;
}): Promise<StaffOrgDashboardApiInvoice[]> {
  return getJson<{ invoices: StaffOrgDashboardApiInvoice[] }>(
    `/data/staff/invoices?number=${number}&outstanding=${outstanding.toString()}`,
  ).then(({ invoices }) => invoices);
}
